export default __webpack_public_path__ + "re_landscape-500-0dbcf2f366217f2ffec84ed83bbd22b7.png";